import { PREF_KEY } from "../constants/userpref";
const getExistingMngSetsSelected = ({ preferences, sets, context, }) => {
    var _a;
    const slcSetId = (_a = preferences === null || preferences === void 0 ? void 0 : preferences[PREF_KEY.jsonstoreContext]) === null || _a === void 0 ? void 0 : _a[context];
    if (!slcSetId)
        return undefined;
    const slcSet = sets.find((set) => set.id === slcSetId);
    return slcSet ? { slcSetId, slcSet } : undefined;
};
const getMngSetsSelected = (context, preferences, sets) => {
    var _a;
    if (!context || !preferences || !sets) {
        return { slcSetId: "", slcSet: undefined };
    }
    const existing = getExistingMngSetsSelected({ preferences, sets, context });
    if (existing !== undefined) {
        return existing;
    }
    // gestisco l'active salvato nei vecchi sets
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const slcIdActv = (_a = sets.find((s) => s.payload.active)) === null || _a === void 0 ? void 0 : _a.id;
    const slcStActv = sets.find((s) => s.id === slcIdActv);
    if (!!slcStActv) {
        return { slcSetId: slcIdActv, slcSet: slcStActv };
    }
    return { slcSetId: "", slcSet: undefined };
};
export default getMngSetsSelected;
